import { keepPreviousData, useQuery } from "@tanstack/react-query"

import { v1FetchActiveSessions } from "@be-miniapp/api"
import { useTranslation } from "@be-miniapp/i18n"

interface ModalActions {
  show: (options: {
    title: string
    message: string
    primaryLabel: string
    onPrimaryAction: () => void
  }) => void
  close: () => void
}

interface ActiveSessionsQueryData {
  data: {
    engagementId: string
    currentState: string
  }
  accessToken: string | undefined | null
  logout: (...args: unknown[]) => void
  modal: ModalActions
  refetchInterval?: number
}

export const activeSessionsQueryKey = {
  all: ["active-sessions"],
  activeSessions: (engagementId: string, currentState: string) => [
    ...activeSessionsQueryKey.all,

    engagementId,
    currentState,
  ],
}

export function useActiveSessions({
  data: { engagementId, currentState },
  accessToken,
  logout,
  modal,
  refetchInterval = 5000,
}: ActiveSessionsQueryData) {
  const { t } = useTranslation()

  return useQuery({
    queryKey: activeSessionsQueryKey.activeSessions(engagementId, currentState),
    queryFn: async () => {
      const resp = await v1FetchActiveSessions({})

      if (resp.flag === 101) {
        logout()
        modal.show({
          title: t("session_expired_title"),
          message: t("session_expired_description"),
          primaryLabel: t("common.ok"),
          onPrimaryAction: (): void => {
            modal.close()
          },
        })
      }

      return resp
    },

    enabled: !!accessToken,
    refetchInterval,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    retry: 1,
  })
}
